import React from 'react';
import { TextControl } from '@wordpress/components';

export const AttributesEditor = ({ blockAttributes, attributes, setAttributes }) => {
    return Object.keys(blockAttributes).map(name => {
        const attribute = blockAttributes[name];
        const label = snakeCaseToSentenceCase(name);

        if (attribute.type === 'string') {
            return (
                <TextControl
                    label={label}
                    type="text"
                    value={attributes[name]}
                    onChange={(value) => setAttributes({ ...attributes, [name]: value })}
                />);
        }

        return null
    })
}

export default AttributesEditor

function snakeCaseToSentenceCase(str) {
    str = str.replace(/([a-z])([A-Z])/g, '$1 $2');
    return str.charAt(0).toUpperCase() + str.slice(1);
}